import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import ProfileHeader from '../../../components/ProfileHeader'
import { getTicketsAll } from '../../../api/TicketsApi'
import ProfileBottomNav from '../../../components/ProfileBottomNav'
import {
  DataGridPremium,
  esES,
  GridColDef,
  GridEventListener, GridRenderCellParams,
} from '@asf-libs/x-data-grid-premium'
import { TOKEN_SO_KEY, USER_SO_KEY } from '../../../utils/accountUtils'
import {
  getSessionStorage,
  setSessionStorage,
} from '../../../utils/StorageUtil'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import IconButton from '@mui/material/IconButton'
import { Trans } from 'react-i18next'
import AddIcon from '@mui/icons-material/Add'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import ConsultService from './consultService'
import {
  MAINT_TYPE_EQ,
  MAINT_TYPE_PAINT,
  MAINT_TYPE_REPAIRS,
  MAINT_TYPE_SERVICE,
} from '../../../utils/generalConstants'
import Stack from '@mui/material/Stack'
import TicketDraftApi from '../../../api/TicketDraftApi'
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function ConsultTickets() {
  const [value, setValue] = React.useState('1')
  const { domain, id } = useParams()
  const navigate = useNavigate()

  const user = getSessionStorage(USER_SO_KEY);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  //const user = getSessionStorage(USER_SO_KEY);
  const handleRequireAssistance = () => {
 
      navigate(`/web/create-maintenance`)
  
  }

  const getColumns = () => {
    let columns: GridColDef[] = [
      {
        field: 'edit',
        headerName: '',
        width: 40,
        renderCell: (params: GridRenderCellParams<any>) => (
          <strong>
            <IconButton className="primary text" size="small" tabIndex={params.hasFocus ? 0 : -1} onClick={()=> handleRowClick(params.row.id)} >
              <BuildOutlinedIcon />
            </IconButton>
          </strong>
        ),
      },
      {
        field: 'numberPlate',
        headerName: 'Dominio',
        width: 100,
        align: 'left',
      },
      {
        field: 'title',
        headerName: 'Titulo',
        width: 260,
        align: 'left',
      },
      {
        field: 'date',
        headerName: 'Fecha',
        width: 100,
      },
      {
        field: 'status',
        headerName: 'Estado',
        width: 130,
      },
      {
        field: 'idTicket',
        headerName: 'Nro Ticket',
        width: 120,
      },

    ]

    return columns
  }

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    let companyID:String | null;
    if (user?.role == "RESPONSABLE_FLOTA") {
      console.log(user);
      companyID=user?.company?.id;
      }else{
        companyID=null;
      }

      getTicketsAll(companyID).then((response) => {
        const dataRows = response?.data?.map((d: any, index: number) => {
          return {
            id: d.id,
            numberPlate: d?.unit?.numberPlate,
            idTicket: d.idTicket,
            userID: d.userID,
            title: d.title,
            status: d.status,
            company: d.company,
            date: moment(d.date).format('DD-MM-YYYY'),
          }
        })
        setRows(dataRows ? dataRows : [])
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
        console.log('Error', e)
      })
    
      


  }, [])

  const handleRowClick = (params: { row: { id: any } }) => {
    navigate(`/web/authorize-maintenance/${params}`)
  }

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <Box sx={{ background: '#F2F3F1' }}>
      <ProfileHeader></ProfileHeader>
      <Box sx={{ margin: '0 4%' }}>
        <Stack
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
          mt={2}
        >
          <Box flexGrow="1">
            <h3><IconButton color="primary" onClick={handleBack}>
              <ArrowBackIcon />
            </IconButton> Tickets</h3>
          </Box>
          <Box flexGrow="1" textAlign="right">
            <h3>{domain?.toUpperCase()}</h3>
          </Box>
        </Stack>

        <Box
          sx={{
            typography: 'body1',
            borderRadius: '16px',
            background: '#ffffff',
          }}
        >
              <div style={{ maxHeight: 250, overflow: 'auto' }}>
                <div style={{ width: '100%', height: '100%' }}>
                  <div style={{ flexGrow: 1 }}>
                    <DataGridPremium
                      localeText={
                        esES.components.MuiDataGrid.defaultProps.localeText
                      }
                      rows={rows}
                      autoHeight={true}
                      columns={getColumns()}
                      density="compact"
                      sx={{
                        border: 0,
                        '& .super-app-theme--header': {
                          fontWeight: '900',
                        },
                        '& .MuiDataGrid-row.Mui-selected': {
                          backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        },
                      }}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>

                
        </Box>
        <Box
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <IconButton
            disabled={!getSessionStorage(TOKEN_SO_KEY)}
            className="consult-maintenance-icon-button"
            onClick={handleRequireAssistance}
          >
            <AddIcon />
            <Trans
              i18nKey={`screens.consultMaintenance.newApplication`}
            ></Trans>
          </IconButton>
        </Box>
      </Box>
      <ProfileBottomNav />
    </Box>
  )
}
